import { clientResourceMapping } from '../../../mocks/logistics';

const ResourceMatching = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-neutral-800 mb-4">
            资源 × 客户类型适配说明
          </h2>
          <p className="text-lg text-neutral-600">
            让客户不再问"我该选哪个"，也不让他们觉得资源是随便用的
          </p>
        </div>

        <div className="overflow-x-auto">
          <div className="min-w-full">
            {/* 表头 */}
            <div className="grid grid-cols-4 gap-4 bg-[#1A3A5C] text-white p-4 rounded-t-xl font-medium">
              <div>客户类型</div>
              <div>推荐物流</div>
              <div>推荐仓储</div>
              <div>匹配原因</div>
            </div>

            {/* 表格内容 */}
            <div className="space-y-0">
              {clientResourceMapping.map((mapping, index) => (
                <div
                  key={index}
                  className={`grid grid-cols-4 gap-4 p-4 border-l border-r border-b border-neutral-200 ${
                    index % 2 === 0 ? 'bg-neutral-50' : 'bg-white'
                  }`}
                >
                  <div className="font-medium text-neutral-800">
                    <span className="bg-[#F7931E]/10 text-[#F7931E] px-3 py-1 rounded-full text-sm">
                      {mapping.clientType}
                    </span>
                  </div>
                  <div className="text-neutral-700">
                    <span className="bg-blue-50 text-blue-600 px-2 py-1 rounded text-sm">
                      {mapping.recommendedLogistics}
                    </span>
                  </div>
                  <div className="text-neutral-700">
                    <span className="bg-green-50 text-green-600 px-2 py-1 rounded text-sm">
                      {mapping.recommendedStorage}
                    </span>
                  </div>
                  <div className="text-neutral-600 text-sm">
                    {mapping.reason}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 移动端横向滚动卡片 */}
        <div className="md:hidden mt-8">
          <div className="flex gap-4 overflow-x-auto pb-4">
            {clientResourceMapping.map((mapping, index) => (
              <div
                key={index}
                className="flex-shrink-0 w-72 bg-white border border-neutral-200 rounded-xl p-6"
              >
                <div className="mb-4">
                  <span className="bg-[#F7931E]/10 text-[#F7931E] px-3 py-1 rounded-full text-sm font-medium">
                    {mapping.clientType}
                  </span>
                </div>
                <div className="space-y-3">
                  <div>
                    <span className="text-xs text-neutral-500">推荐物流：</span>
                    <div className="mt-1">
                      <span className="bg-blue-50 text-blue-600 px-2 py-1 rounded text-sm">
                        {mapping.recommendedLogistics}
                      </span>
                    </div>
                  </div>
                  <div>
                    <span className="text-xs text-neutral-500">推荐仓储：</span>
                    <div className="mt-1">
                      <span className="bg-green-50 text-green-600 px-2 py-1 rounded text-sm">
                        {mapping.recommendedStorage}
                      </span>
                    </div>
                  </div>
                  <div>
                    <span className="text-xs text-neutral-500">匹配原因：</span>
                    <p className="text-neutral-600 text-sm mt-1">
                      {mapping.reason}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResourceMatching;